export const messages = {
  title: 'Utforsk NIO\nAPP og bli en del av vårt samfunn.',
  description: 'NIO APP kobler deg til vårt samfunn. Den gir deg eksklusivt innhold, og de siste nyhetene om NIO produkter og tjenester. APP gir deg og muligheten til betjene ditt fremtidige NIO kjøretøy.',
  downloadIos: 'Last ned for iOS',
  downloadAndroid: 'Last ned for Android'
}
